/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';
import { getStatic } from '../../../local-storage';
import {
  addFollows,
  clearInvitationCode,
  loadingSignalFollows,
  removeFollow,
  setFollows,
  setInvitationCode,
} from './actions';
import { FollowModel, transformApiToLocalModel } from './models';

export interface FollowsState {
  signalFollowsLoading: boolean;
  follows: {
    [key: string]: FollowModel;
  };
  invitationCode: string | null;
}

const initialState: FollowsState = {
  follows: {},
  signalFollowsLoading: false,
  invitationCode: getStatic('follows', 'invitationCode') || null,
};

export const reducer = createReducer(initialState, (builder) => {
  builder.addCase(loadingSignalFollows, (state, action) => {
    state.signalFollowsLoading = action.payload;
  });

  builder.addCase(setFollows, (state, action) => {
    const follows = action.payload.map(transformApiToLocalModel);
    state.follows = follows.reduce(
      (acc, item) => {
        acc[item.id] = item;
        return acc;
      },
      {} as Record<string, FollowModel>,
    );
  });

  builder.addCase(removeFollow, (state, action) => {
    delete state.follows[action.payload];
  });

  builder.addCase(addFollows, (state, action) => {
    const followsToAdd = action.payload.map(transformApiToLocalModel);
    state.follows = followsToAdd.reduce((acc, item) => {
      acc[item.id] = item;
      return acc;
    }, state.follows);
  });

  builder.addCase(setInvitationCode, (state, action) => {
    state.invitationCode = action.payload;
  });

  builder.addCase(clearInvitationCode, (state) => {
    state.invitationCode = initialState.invitationCode;
  });
});
